<script lang="ts">
import { useFilterStub } from './filter-stub';
import { LocalFilterModel } from './FilterText.vue';
</script>

<script setup lang="ts">
defineExpose(
  useFilterStub<string, LocalFilterModel>(
    {
      filter: '',
      type: 'equals',
    },
    ({ filter }) => filter !== '',
    ({ filter, type }, value = '') => {
      filter = filter.toLocaleLowerCase();
      value = value.toLocaleLowerCase();
      return type === 'contains' ? value.includes(filter) : filter === value;
    }
  )
);
</script>

<!-- eslint-disable-next-line vue/valid-template-root -->
<template></template>
